exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb10[data-v-38de659e] {\r\n\tmargin-bottom: 10px;\n}\n.colBlue[data-v-38de659e]{\r\n\tcolor: blue;\n}\n.colBlack[data-v-38de659e]{\n  color: black;\n}\n.colRed[data-v-38de659e]{\n  color: red;\n}\r\n", ""]);

// exports
